module.exports = __webpack_public_path__ + "images/psp/FeaturedImages/24HourFeatured2.webp";